<template>
  <div class="white_box">
    <div
      class="title"
      @click="$parent.showAddKeyword = !$parent.showAddKeyword"
    >
      <h3 class="heading">
        {{ canEditKeywords ? 'Add keyword idea' : 'Keyword ideas' }}
      </h3>

      <button :class="'arrow_btn '+(open ? 'open' : '')" />
    </div>

    <accordion-transition>
      <div
        v-if="open"
        class="add_wrapper"
      >
        <div
          v-if="canEditKeywords"
          class="add_form"
        >
          <input
            v-model="keyword"
            autocomplete="off"
            class="add_input"
            placeholder="New Keyword"
            type="text"
          >

          <button
            :disabled="loading"
            class="btn primary_btn btn_md"
            @click="addKeyword(keyword)"
          >
            <i
              v-if="loading"
              class="fas fa-spinner fa-spin"
            />
            {{ loading ? 'Adding Keyword' : 'Add Keyword' }}
          </button>

          <small
            v-if="error"
            class="text-danger text-center"
          >
            {{ error }}
          </small>
        </div>

        <topic-tabs
          v-if="previousTopics !== null && suggestedTopics !== null"
          @error="(newError) => error = newError"
        />
      </div>
    </accordion-transition>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapGetters} from 'vuex';
import AccordionTransition from './../../../../reports/components/global/transitions/AccordionTransition.vue';
import TopicTabs from "./TopicTabs.vue";

export default {
  components: {
    TopicTabs,
    AccordionTransition
  },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyword: '',
      loading: false,
      prefillBulkAdd: '',
      error: null,
      activeTab: 'previous',
    }
  },
  computed: {
    ...mapGetters('keywordIdeas', [
      'previousTopics',
      'suggestedTopics',
      'chosenKeywords',
      'suggestions',
      'keywordFilter',
    ]),
    ...mapGetters('user', [
      'canEditKeywords',
    ]),
  },
  watch: {
    keyword() {
      const parsedForBulk = this.keyword.split(',').map(keyword => keyword.trim());
      this.updateBulkAddPrefill(parsedForBulk.join('\n'));
      this.checkKeywordLength();
    },
  },
  methods: {
    ...mapActions('keywordIdeas', [
        'setFilter',
        'addKeywordSuggestion',
        'openBulkAddModal',
        'updateBulkAddPrefill'
    ]),
    checkKeywordLength() {
      if (this.keyword.length > 70) {
        this.error = `Maximum 70 characters`;
      } else {
        this.error = null;
      }
    },
    warnKeywordLength(commaDetected) {
      let message = "Please limit your keyword ideas to a maximum of 70 characters.";
      if (commaDetected === true) {
        message = `
                It looks like you might be trying to add a comma-separated list of keywords.
                If you would like to add keywords in bulk,
                please use the "Bulk add keywords" tool.<hr>
                If that's not the case, please try removing any commas from your keyword and try again.
            `;
      }
      Swal.fire({
        title: commaDetected ?
            `Bulk add detected` :
            `Keyword length exceeded`,
        icon: 'warning',
        html: message,
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Close',
        showConfirmButton: commaDetected,
        confirmButtonText: 'Use bulk add',
        backdrop: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: commaDetected ? () => {
          this.openBulkAddModal();
        } : null,
      });
    },
    addKeyword(keyword) {
      keyword = keyword.trim().toLowerCase();

      const commaDetected = keyword.indexOf(',') > -1;
      if (keyword.length > 70 || commaDetected) {
        this.warnKeywordLength(commaDetected);
        return;
      }

      this.loading = true;
      this.error = null;

      if (!keyword) {
        this.error = 'Please enter a keyword';
        this.loading = false;
        return;
      }
      let exists = this.previousTopics.find(topic => topic.keyword_topic === keyword);
      if (exists) {
        this.loading = false;
        this.error = 'This keyword already exists. Applied filter';
        this.setFilter({key: 'keywordFilter', value: keyword});
      } else {
        this.addKeywordSuggestion(keyword)
          .then((count) => {
            if (!count || count === 0) {
              this.error = 'We found no suggestions for this keyword. Please try another keyword';
            }
            this.keyword = '';
            this.loading = false;
            this.setFilter({
              key: 'keywordFilter',
              value: keyword
            });
          }).catch(({data}) => {
            this.error = data.message;
            this.loading = false;
          });
      }
    },
  },
}
</script>

<style scoped>
.white_box {
  margin-bottom: 1rem;
}

.sub_heading, .bulk_add {
  font-size: 0.875rem;
  line-height: 1.72;
  letter-spacing: -0.00715em;
  color: var(--secondary-font-color);
  font-weight: 700;
}
</style>
